import { enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import anime from 'animejs';

export default {
    init() {
        //////////// Navigation
        const menu = document.getElementById('menu');
        const hamburger = document.getElementById('hamburger');
        const header = document.querySelector('.header-menu');
        const body = document.querySelector('body');
        const closeOverlay = document.querySelector('.header-overlay');

        const durationDesktop = 700;
        const durationMobile = 400;
        const offsetSlideOut = 40;

        if (!menu || !hamburger || !header || !body || !closeOverlay) {
            return;
        }

        // Store the window width
        let windowWidth = window.innerWidth;

        // We listen to the resize event
        window.addEventListener('resize', () => {
            // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
            if (window.innerWidth != windowWidth) {
                // Update the window width for next time
                windowWidth = window.innerWidth;

                if (menu.classList.contains('open')) {
                    menu.classList.remove('open');
                    hamburger.classList.remove('close');
                    header.classList.remove('open-menu');
                    body.classList.remove('overflow-hidden');
                    body.classList.remove('fixed');
                }
                setTimeout(resetMenu, 20); // reset menu animations + add timeout to fix menu bug when resizing

                if (header.classList.contains('subbutton-menu-open')) {
                    header.classList.remove('subbutton-menu-open');
                }

                const menuPanels = menu.querySelectorAll(
                    '.subbuttons'
                ) as NodeListOf<HTMLElement>;
                if (isDesktop()) {
                    if (!menuPanels.length) {
                        return;
                    }

                    menuPanels.forEach(function (menuPanel: HTMLElement) {
                        menuPanel.style.height = 'auto';
                        menuPanel.style.transform =
                            'translateY(' +
                            (-menuPanel.clientHeight -
                                menu.clientHeight -
                                offsetSlideOut) +
                            ')';
                    });
                } else {
                    menuPanels.forEach(function (menuPanel: HTMLElement) {
                        menuPanel.style.transform = 'translateY(0)';
                    });
                }
            }

            // Otherwise do nothing
        });

        if (hamburger) {
            hamburger.addEventListener('click', function () {
                const timeline = anime.timeline({
                    duration: 400,
                    easing: 'easeOutQuint'
                });

                // close menu
                if (menu.classList.contains('open')) {
                    menu.classList.remove('open');
                    hamburger.classList.remove('close');
                    header.classList.remove('open-menu');
                    body.classList.remove('overflow-hidden');
                    body.classList.remove('fixed');

                    timeline.add({
                        targets: '#menu',
                        opacity: 0,
                        complete: () => {
                            clearAllBodyScrollLocks();
                        }
                    });
                } else {
                    // open menu
                    enableBodyScroll(header);
                    menu.classList.add('open');
                    hamburger.classList.add('close');
                    header.classList.add('open-menu');
                    body.classList.add('overflow-hidden');
                    body.classList.add('fixed');

                    timeline.add({
                        targets: '#menu',
                        opacity: 1,
                        complete: () => {
                            enableBodyScroll(header);
                        }
                    });
                }
            });
        }

        const isDesktop = () => {
            return window.innerWidth >= 1024;
        };

        const openMenuMobile = (menuEntry: HTMLElement) => {
            const menuEntryId = menuEntry.dataset.targetIndex;
            // get all mobile menu panels
            const menuPanelsMobile = document.querySelectorAll(
                '.subbuttons-mobile'
            ) as NodeListOf<HTMLElement>;
            // get all content index ids + compare wit menuEntryId --> if same, add max heigth
            if (menuPanelsMobile.length) {
                menuPanelsMobile.forEach((panel) => {
                    const subbuttonsMobileId = panel.dataset.contentIndex;
                    if (menuEntryId === subbuttonsMobileId) {
                        if (panel.classList.contains('max-h-0')) {
                            panel.classList.remove('max-h-0');
                        }
                        if (panel.classList.contains('overflow-hidden')) {
                            panel.classList.remove('overflow-hidden');
                        }
                    }
                });
            }
            menuEntry.classList.add('button-active');
        };

        const closeMenuMobile = (menuEntry: HTMLElement, animate = true) => {
            const menuEntryId = menuEntry.dataset.targetIndex;
            // get all mobile menu panels
            const menuPanelsMobile = document.querySelectorAll(
                '.subbuttons-mobile'
            ) as NodeListOf<HTMLElement>;
            // get all content index ids + compare wit menuEntryId --> if same, add max heigth
            if (menuPanelsMobile.length) {
                menuPanelsMobile.forEach((panel) => {
                    const subbuttonsMobileId = panel.dataset.contentIndex;
                    if (menuEntryId === subbuttonsMobileId) {
                        panel.classList.add('max-h-0');
                        panel.classList.add('overflow-hidden');
                    }
                });
            }
            if (menuEntry.classList.contains('button-active')) {
                menuEntry.classList.remove('button-active');
            }
        };

        const crossFadeMenuMobile = (
            newMenuEntry: HTMLElement,
            oldMenuEntry: HTMLElement
        ) => {
            closeMenuMobile(oldMenuEntry);
            openMenuMobile(newMenuEntry);
        };

        const openMenuDesktop = (menuEntry: HTMLElement, animate = true) => {
            const menuPanel = menuEntry.querySelector(
                '.subbuttons'
            ) as HTMLElement;
            menuPanel.style.opacity = '1';
            const header = document.querySelector('.header-menu');
            header?.classList.add('subbutton-menu-open');
            closeOverlay.classList.remove('hidden');
            menuEntry.classList.add('button-active');
            anime({
                targets: menuPanel,
                translateY: [
                    -menuPanel.clientHeight -
                        menu.clientHeight -
                        offsetSlideOut,
                    0
                ],
                duration: animate ? durationDesktop : 0,
                easing: 'easeInOutCirc'
            });
            const currentActiveStateButton = document.querySelector(
                '.active-tab'
            ) as HTMLElement;
            if (currentActiveStateButton) {
                currentActiveStateButton.classList.remove('active-tab');
            }
        };

        const closeMenuDesktop = (menuEntry: HTMLElement, animate = true) => {
            const menuPanel = menuEntry.querySelector(
                '.subbuttons'
            ) as HTMLElement;
            if (!menuPanel) return;
            menuPanel.style.opacity = '1';
            const header = document.querySelector('.header-menu');
            header?.classList.remove('subbutton-menu-open');
            closeOverlay.classList.add('hidden');
            menuEntry.classList.remove('button-active');
            anime({
                targets: menuPanel,
                translateY: [
                    0,
                    -menuPanel.clientHeight -
                        menu.clientHeight -
                        offsetSlideOut +
                        '5px'
                ],
                duration: animate ? durationDesktop : 0,
                easing: 'easeInOutCirc'
            });
            // const currentActiveStateButton = document.querySelector(
            //     '.active-tab'
            // ) as HTMLElement;
            // console.log(currentActiveStateButton);
            // if (currentActiveStateButton) {
            //     currentActiveStateButton.classList.remove('active-tab');
            // }
        };

        const crossFadeMenuDesktop = (
            newMenuEntry: HTMLElement,
            oldMenuEntry: HTMLElement
        ) => {
            const timeline = anime.timeline({
                duration: durationMobile,
                easing: 'linear'
            });
            const newMenuPanel = newMenuEntry.querySelector(
                '.subbuttons'
            ) as HTMLElement;
            const oldMenuPanel = oldMenuEntry.querySelector(
                '.subbuttons'
            ) as HTMLElement;

            newMenuEntry.classList.add('button-active');
            oldMenuEntry.classList.remove('button-active');

            timeline
                .add({
                    targets: newMenuPanel,
                    duration: 1,
                    translateY: [
                        -newMenuPanel.clientHeight -
                            menu.clientHeight -
                            offsetSlideOut,
                        0
                    ]
                })
                .add({
                    targets: oldMenuPanel,
                    opacity: [1, 0]
                })
                .add(
                    {
                        targets: newMenuPanel,
                        opacity: [0, 1]
                    },
                    `-=${durationMobile}`
                )
                .add({
                    targets: oldMenuPanel,
                    duration: 1,
                    translateY: [
                        0,
                        -oldMenuPanel.clientHeight -
                            menu.clientHeight -
                            offsetSlideOut
                    ]
                });
        };

        //// hide + show subbuttons

        const menuEntryWithSubButtons = document.querySelectorAll(
            '.has-subbuttons'
        ) as NodeListOf<HTMLElement>;

        if (!menuEntryWithSubButtons) {
            return;
        }

        let currentSubMenuEntry = null as any;

        const resetMenu = () => {
            currentSubMenuEntry = null;
            menuEntryWithSubButtons.forEach((element: HTMLElement) => {
                isDesktop()
                    ? closeMenuDesktop(element, false)
                    : closeMenuMobile(element, false);
            });
        };

        resetMenu(); // apply default menu state
        menuEntryWithSubButtons.forEach((element: HTMLElement) => {
            element?.addEventListener('click', function () {
                const menuEntry = element;
                if (!currentSubMenuEntry) {
                    isDesktop()
                        ? openMenuDesktop(menuEntry)
                        : openMenuMobile(menuEntry);
                    currentSubMenuEntry = menuEntry;
                } else if (currentSubMenuEntry === menuEntry) {
                    isDesktop()
                        ? closeMenuDesktop(menuEntry)
                        : closeMenuMobile(menuEntry);
                    currentSubMenuEntry = null;
                } else {
                    isDesktop()
                        ? crossFadeMenuDesktop(menuEntry, currentSubMenuEntry)
                        : crossFadeMenuMobile(menuEntry, currentSubMenuEntry);
                    currentSubMenuEntry = menuEntry;
                }
            });
        });

        // menuEntryWithSubButtons.forEach((element: HTMLElement) => {
        //     element?.addEventListener('click', function (event: Event) {
        //         const menuEntry = element;
        //         // const target = event.target as HTMLElement;

        //         // // Check if the clicked target is a link (<a> element)
        //         // const isLink = target.tagName.toLowerCase() === 'a';
        //         // console.log(isLink);
        //         const links = element.querySelectorAll('a') as NodeListOf<HTMLAnchorElement>;

        //         links.forEach((link: HTMLAnchorElement) => {
        //             link.addEventListener('click', function (event: Event) {
        //                 // Prevent the default link behavior (e.g., navigating to a new page)
        //                 event.preventDefault();
        //             });
        //         });

        //         element?.addEventListener('click', function () {
        //             const menuEntry = element;
        //             if (!currentSubMenuEntry) {
        //                 isDesktop()
        //                     ? openMenuDesktop(menuEntry)
        //                     : openMenuMobile(menuEntry);
        //                 currentSubMenuEntry = menuEntry;
        //             } else if (currentSubMenuEntry === menuEntry) {
        //                 isDesktop()
        //                     ? closeMenuDesktop(menuEntry)
        //                     : closeMenuMobile(menuEntry);
        //                 currentSubMenuEntry = null;
        //             } else {
        //                 isDesktop()
        //                     ? crossFadeMenuDesktop(menuEntry, currentSubMenuEntry)
        //                     : crossFadeMenuMobile(menuEntry, currentSubMenuEntry);
        //                 currentSubMenuEntry = menuEntry;
        //             }
        //         });
        //     });
        // });

        // add scroll styling for header
        window.onscroll = function () {
            if (document.documentElement.scrollTop > header.clientHeight) {
                header.classList.add('bg-scroll');
            } else {
                header.classList.remove('bg-scroll');
            }
        };

        // let lastScrollTop = 0;

        // handleHeaderScroll(
        //     window.pageYOffset || document.documentElement.scrollTop
        // );

        // const isCtaMenu = header.classList.contains('header-menu-cta');

        // window.addEventListener(
        //     'scroll',
        //     function () {
        //         const windowScrollTop =
        //             window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        //         handleHeaderScroll(windowScrollTop, isCtaMenu);
        //     },
        //     false
        // );

        // function handleHeaderScroll(scrollTop: number, isCtaMenu = false) {
        //     if (scrollTop <= 0) {
        //         header?.classList.remove('bg-white');
        //         // header?.classList.remove('header-bg-white');
        //     } else {
        //         header?.classList.add('bg-white');
        //         // header?.classList.add('header-bg-white');
        //     }

        //     if (!isCtaMenu) {
        //         return;
        //     }

        //     if (scrollTop > lastScrollTop) {
        //         // downscroll code
        //         header?.classList.add('cta-show');
        //     } else {
        //         // upscroll code
        //         header?.classList.remove('cta-show');
        //     }
        //     lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
        // }

        // close menu when clicking outside of div
        closeOverlay.addEventListener('click', function () {
            const activeMenuItem = document.querySelector(
                '.button-active'
            ) as HTMLElement;
            closeMenuDesktop(activeMenuItem);
            currentSubMenuEntry = null;
        });
    }
};
